import React from 'react';
import { styled } from '@mui/system';
const Header = styled('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: "space-between"
});
const HeaderDiv = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Header, props, props.children));
export default HeaderDiv;